import React from 'react';

const ScanDataContext = React.createContext();

export default ScanDataContext;
